import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { csmBaseUrlResource } from '@jira/router-resources__service-desk-customer-service-csm-base-url/src/csmBaseUrlResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmExperiencesRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperiencesRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

import { helpCenterSettingsServiceHubsRoutePageEntryPoint } from './ui/service-hubs/index.tsx';

export const csmExperiencesRouteEntry: Route = createEntry(csmExperiencesRoute, () => ({
	group: 'customer-service',
	perfMetricKey: 'customer-service.csm-experiences',
	layout: globalLayout,
	navigation: {
		menuId: MenuIdCustomerExperiences,
		sidebarId: SidebarIdCsmApp,
	},
	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? helpCenterSettingsServiceHubsRoutePageEntryPoint
			: notFoundPageEntrypoint;
	},
	resources: [
		...getCustomerServiceL1NavigationResources(),
		csmBaseUrlResource,
		customerExperiencesNavigationResource,
	],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
